<template>
  <div>
    <b-card
      style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 640px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;"
    >
      <!-- Loading Overlay -->
      <div
        v-if="isLoading"
        class="loading-overlay"
      >
        <b-spinner
          variant="success"
          label="กำลังโหลด..."
        />
        <div class="loading-text">
          กำลังโหลดข้อมูล
        </div>
      </div>

      <div>
        <l-map
          ref="mymap"
          :zoom="zoom"
          :center="center"
          style="width: 100%; height: 590px; z-index: 0"
          :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false, dragging:true, doubleClickZoom: true, permanent: true}"
          @ready="handleMapReady"
        >
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          />

          <!-- Database Markers -->
          <template v-if="!isLoading">
            <l-marker
              v-for="(markerDB, index) in markersDB"
              :key="'markerDB'+index"
              ref="markerDB"
              :lat-lng="[markerDB.latitude, markerDB.longitude]"
              @click="getInfoCountingDB(markerDB.wid, markerDB.deptid, markerDB.wayid, markerDB.type_name, markerDB.analyticType, markerDB.analyticGroup)"
            >
              <l-icon
                v-if="markerDB.type_name === 'Counting' || markerDB.type_name === 'Counting7'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Counting.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'TrafficSign'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/VMS Sign.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'Traffic'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Traffic.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'Flooding'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Flooding.svg')"
              />
              <l-icon
                v-if="markerDB.type_name !== 'Counting' & markerDB.type_name !== 'Counting7'
                  & markerDB.type_name !== 'TrafficSign'
                  & markerDB.type_name !== 'Traffic' & markerDB.type_name !== 'Flooding'
                  & markerDB.type_name !== 'Lighting' & markerDB.type_name !== 'Foodlight'
                  & markerDB.type_name !== 'Analytic' & markerDB.type_name !== 'Tunnel'
                  & markerDB.type_name !== 'Bridge' & markerDB.type_name !== 'Kiosk'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Sensor.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'Lighting'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Lighting.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'FloodLight'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Foodlight.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'Analytic'"
                :icon-size="[24, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Analytic.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'Tunnel'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Tunnel.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'Bridge'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Bridge.svg')"
              />
              <l-icon
                v-if="markerDB.type_name === 'Kiosk'"
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/iconsDB/Kiosk.svg')"
              />

              <!-- ปริมาณจราจร -->
              <l-popup
                v-if="markerDB.type_name === 'Counting' || markerDB.type_name === 'Counting7'"
                ref="popup"
              >
                <div>
                  <span style="font-size: 17px; color:#fff;">ปริมาณจราจร</span>
                  <b-table
                    class="table table-borderless"
                    style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                    responsive="sm"
                    :items="itemsDB"
                    :fields="fieldsmarkersDB"
                    small
                    stacked
                  >
                    <template
                      #cell(wid)="data"
                      colspan="2"
                    >
                      <b-button
                        id="toggle-btn"
                        variant="success"
                        :to="`/counting-detail?wid=${data.item.wid}`"
                      >
                        <span>ดูเพิ่มเติม</span>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </l-popup>

              <!-- ป้าย VMS -->
              <l-popup
                v-if="markerDB.type_name === 'TrafficSign'"
                ref="popup"
              >
                <div>
                  <span style="font-size: 17px; color:#fff;">ป้าย VMS</span>
                  <b-table
                    class="table table-borderless"
                    style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                    responsive="sm"
                    :items="itemsDB"
                    :fields="fieldsmarkersTrafficSign"
                    small
                    stacked
                  >
                    <template
                      #cell(wid)="data"
                      colspan="2"
                    >
                      <b-button
                        id="toggle-btn"
                        variant="success"
                        :to="`/vms-detail?wid=${data.item.wid}`"
                      >
                        <span>ดูเพิ่มเติม</span>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </l-popup>

              <!-- ... (เพิ่ม Popups อื่นๆ เหมือนโค้ดเดิม) ... -->
            </l-marker>
          </template>

          <!-- CCTV Markers -->
          <template v-if="!isLoading">
            <l-marker
              v-for="(marker, index) in markercctv"
              :key="'marker'+index"
              :ref="'marker'+index"
              :lat-lng="[marker.latitude, marker.longitude]"
              :options="{ autoClose: false, closeOnClick: false }"
              @click="getInfoCount(marker.wayid, marker.detail, marker.id)"
            >
              <l-icon
                :icon-size="[20, 46]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/MakerCCTV.svg')"
              />
              <l-popup
                ref="popup"
              >
                <div>
                  <span style="font-size: 17px; color:#fff;">กล้องวงจรปิด</span>
                  <b-table
                    class="table table-borderless"
                    style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                    responsive="lg"
                    :items="itemsCount"
                    :fields="fieldsmarkersCCTV"
                    small
                    stacked
                    foot-clone
                  >
                    <template
                      #cell(id)="data"
                      colspan="2"
                    >
                      <b-button
                        id="toggle-btn"
                        variant="success"
                        :to="`/cctv-detail?wid=${data.item.id}`"
                      >
                        <span>ดูเพิ่มเติม</span>
                      </b-button>
                    </template>
                  </b-table>
                </div>
              </l-popup>
            </l-marker>
          </template>

          <!-- Error Alert -->
          <div
            v-if="showError"
            class="error-alert"
          >
            <b-alert
              show
              variant="danger"
              dismissible
              @dismissed="showError = false"
            >
              <strong>เกิดข้อผิดพลาด!</strong> ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง
            </b-alert>
          </div>
        </l-map>
      </div>
    </b-card>

    <!-- Retry Button when Error -->
    <b-row
      v-if="showError"
      class="mt-3"
    >
      <b-col class="text-center">
        <b-button
          variant="success"
          @click="retryLoading"
        >
          โหลดข้อมูลใหม่
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  VBModal,
  BCard,
  BTable,
  BButton,
  BSpinner,
  BAlert,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer,
  LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import Ripple from 'vue-ripple-directive'
import { Icon } from 'leaflet'

// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  // eslint-disable-next-line global-require
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  // eslint-disable-next-line global-require
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // eslint-disable-next-line global-require
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BCard,
    BTable,
    BButton,
    BSpinner,
    BAlert,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 6,
      center: [13.7649084, 100.5360959],
      markersDB: [],
      markercctv: [],
      itemsDB: [],
      attribution: '',
      fieldsmarkersDB: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersCCTV: [
        { key: 'detail', label: 'จุดติดตั้ง:', class: 'text-center' },
        { key: 'id', label: '', class: 'text-center' },
      ],
      fieldsmarkersTrafficSign: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersTraffic: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersFlooding: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersSenser: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersLighting: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersFloodLight: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersAnalytic: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      fieldsmarkersTunnel: [
        {
          key: 'wayid', label: 'สายทาง:',
        },
        {
          key: 'type_name', label: 'สถานะ:',
        },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      itemsCount: [],
      TypeName: ['Counting', 'Counting7', 'CCTV', 'TrafficSign', 'Traffic', 'Flooding', 'Lighting', 'FloodLight', 'Analytic', 'Tunnel', 'Bridge'],
      userData: JSON.parse(localStorage.getItem('userData')),

      // Loading States
      isLoading: true,
      showError: false,
      loadingTasks: 0,
      isMapReady: false,
    }
  },

  created() {
    if (this.userData.groupname === 'psd') {
      this.zoom = 12
    } else if (this.userData.department !== '0') {
      this.zoom = 10
    }
  },

  mounted() {
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
  },

  methods: {
    startLoading() {
      // eslint-disable-next-line no-plusplus
      this.loadingTasks++
      this.isLoading = true
    },

    endLoading() {
      // eslint-disable-next-line no-plusplus
      this.loadingTasks--
      if (this.loadingTasks <= 0) {
        this.isLoading = false
        this.loadingTasks = 0
      }
    },

    handleMapReady() {
      this.isMapReady = true
      this.loadAllData()
    },

    async loadAllData() {
      this.startLoading()
      this.showError = false

      try {
        await Promise.all([
          this.getMarkerDB(),
          this.getMarkerCCTV(),
        ])
      } catch (error) {
        console.error('Error loading data:', error)
        this.showError = true
      } finally {
        this.endLoading()
      }
    },

    async getMarkerDB() {
      try {
        const response = await axios.post('/getMarkerDB', {
          department: this.userData.department,
          owner: this.userData.groupname,
          username: this.userData.username,
        })

        if (this.userData.department !== '0' && response.data.length) {
          const { latitude, longitude } = response.data[0]
          this.center = [latitude, longitude]
        }

        this.markersDB = response.data
      } catch (error) {
        console.error('Error fetching markers:', error)
        throw error
      }
    },

    async getMarkerCCTV() {
      try {
        const response = await axios.post('/getMapTotalCCTV', {
          department: this.userData.department,
          username: this.userData.username,
        })
        this.markercctv = response.data
      } catch (error) {
        console.error('Error fetching CCTV markers:', error)
        throw error
      }
    },

    retryLoading() {
      this.loadAllData()
    },

    // eslint-disable-next-line camelcase
    getInfoCountingDB(wid, deptid, wayid, type_name, analyticType, analyticGroup) {
      this.itemsDB = [{
        wid,
        deptid,
        wayid,
        type_name,
        analyticType,
        analyticGroup,
      }]
    },

    getInfoCount(WayID, detail, id) {
      this.itemsCount = []
      this.itemsCount.push({
        WayID,
        detail,
        id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';

// Map Popup Styles
.leaflet-popup-content {
  margin: 10px 10px;
  width: 250px !important;
  height: 100%;
}

.leaflet-container a.leaflet-popup-close-button {
  padding: 0;
}

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: rgba(36, 36, 36, 0.85);
  box-shadow: 0 3px 14px rgba(0,0,0,0.4);
  border: 1px solid #00B058;
  border-radius: 12px;
}

// Loading Styles
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(24, 24, 24, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  border-radius: 40px 4px 40px 4px;
}

.loading-text {
  margin-top: 1rem;
  color: #00B058;
  font-weight: bold;
}

// Error Alert Styles
.error-alert {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 80%;
  max-width: 500px;
}

// Table Styles
.table {
  &.table-borderless {
    background-color: transparent;

    td {
      border: none;
      color: white;
    }
  }
}

#toggle-btn {
  width: 100%;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(0, 176, 88, 0.2);
  }
}

// Loading Spinner Animation
@keyframes spin {
  to { transform: rotate(360deg); }
}

.spinner-border {
  width: 3rem;
  height: 3rem;
  color: #00B058;
  animation: spin 1s linear infinite;
}

// Fade Transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
